var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1802",
    "data-name": "Gruppe 1802",
    transform: "translate(-267.164 -262.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M295.768,274.426a3,3,0,0,0-.6-.061h-1v-2a3,3,0,0,0-3-3H284.89v-1.779a3,3,0,1,0-4,0v1.778h-6.726a3,3,0,0,0-3,3v2h-1a2.978,2.978,0,0,0-2.961,2.617,2.84,2.84,0,0,0-.039.383v1c0,.056.013.108.016.163a2.993,2.993,0,0,0,2.984,2.837h1v3a3,3,0,0,0,3,3h17a3,3,0,0,0,3-3v-3h1a3,3,0,0,0,3-3v-1A3,3,0,0,0,295.768,274.426Zm-21.1,2.439a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,274.665,276.865Zm5.3,7.073h-.516a1,1,0,0,1-1-1v-.823a1,1,0,0,1,1-1h.516Zm2.419,0H280.97v-2.823h1.419Zm2.42,0h-1.42v-2.823h1.42Zm2.516-1a1,1,0,0,1-1,1h-.516v-2.823h.516a1,1,0,0,1,1,1Zm1.339-3.573a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,288.664,279.365Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(287.164 275.365)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(275.665 275.365)",
    fill: "inherit"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/Robot.7595bf7c35b2c5ced3304cb6a31d2072.svg";
export { ForwardRef as ReactComponent };